import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const HeaderDesktop = styled.div`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  /* height: 114px; */
  z-index: 30;
  position: relative;
  /* position: sticky;
  top: 0; */
  background-color: #fff;
  border-bottom: 1px solid #eee;

  .inner-nav {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    padding: 16px 20px;
  }

  .innv-row-01 {
    ${mixin.flex({ justify: 'space-between' })};

    .area-logo .btn {
      width: 170px;
      height: 22px;
    }

    .nav-utils {
      ${mixin.flex({ justify: 'flex-end' })};
      column-gap: 6px;

      .btn {
        width: 36px;
        height: 36px;
      }

      .cart .btn {
        position: relative;
        ${mixin.flex({ justify: 'flex-start' })}
        padding-left: 3.4px;

        .count {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }

  .innv-row-02 {
    margin-top: 12px;
    ${mixin.flex({ justify: 'flex-end', wrap: 'wrap' })};

    .area-cate-menu {
      z-index: 1;
      order: -1;
    }

    .area-nav {
      padding: 9px 22px;
      height: 40px;
      margin-right: auto;

      .nav-gnb,
      .nav-gnb2 {
        position: relative;
        ${mixin.flex({ display: 'inline-flex', justify: 'flex-start' })}
        column-gap: 14px;

        .btn {
          text-transform: uppercase;
          padding: 0 1px;
          font-size: 17px;
          color: #000;
          font-weight: 500;
          line-height: 130%;

          .ad-tag {
            color: #bbb;
          }
        }
      }

      .nav-gnb2 {
        padding-left: 16px;
        margin-left: 16px;

        &::before {
          content: '';
          width: 1px;
          height: 16px;
          background-color: #e2e2e2;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .area-search {
      position: relative;
    }
  }
`;
